import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import Banner from "../banner";
import Introduction from "../introduction";
import MainServices from "../services";
import MainProducts from "../products";
import MainNews from "../newsandnotice";
import MainSupport from "../support";
import PopUps from "../popups";

import Loading from "../../common/loading";
import Errors from "../../common/error";
import { TabTitle } from "../../common/dynamicTitle";
import { LangContext } from "../../context/LangContext";

const HomePage = () => {
  TabTitle("GMBF | Home");

  const {
    state: { np },
  } = useContext(LangContext);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const APIURL = `${process.env.REACT_APP_URL}home`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setData(response.data);
        // console.log("HOME_______", response.data);
      } catch (err) {
        console.error("Error fetching homepage data:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [APIURL]);

  const aboutdata = np ? data?.about?.np : data?.about?.en;
  const servicesdata = np ? data?.services?.np : data?.services?.en;
  const productsdata = np ? data?.products?.np : data?.products?.en;
  const newsdata = np ? data?.news?.np : data?.news?.en;
  const advertisementdata = np
    ? data?.advertisement?.np
    : data?.advertisement?.en;

  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <PopUps Popupss={data?.popups} />
      <Banner
        banners={data?.banners}
        advertisement={advertisementdata}
        nep={np}
      />
      <Introduction about={aboutdata} nep={np} />
      <MainServices digital={servicesdata} nep={np} />
      <MainProducts product={productsdata} nep={np} />
      <MainNews
        news={newsdata}
        app_store={data?.site_setting?.app_store}
        google_play={data?.site_setting?.google_play}
        nep={np}
      />
      <MainSupport support={data?.support} />
    </>
  );
};

export default HomePage;
